"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    height: 0;\n    overflow: ", ";\n\n    transition: height ", "ms\n      ", ";\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: inherit;\n    color: inherit;\n    background: none;\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    text-align: left;\n    cursor: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    & > h4 {\n      margin: 0;\n      padding: 0;\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    box-sizing: border-box;\n    font-weight: 500;\n    color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: 1px solid ", ";\n    position: relative;\n    &:last-of-type {\n      border-bottom: none;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.Item = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject2(), theme.palette.border["default"]);
});
exports.Text = styled_components_1["default"].div(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme;
  return styled_components_1.css(_templateObject4(), theme.palette.text["default"]);
});
exports.Title = styled_components_1["default"].button(_templateObject5(), function (_ref3) {
  var expanded = _ref3.expanded;
  return styled_components_1.css(_templateObject6(), expanded ? "default" : "pointer");
});
exports.Content = styled_components_1["default"].div(_templateObject7(), function (_ref4) {
  var theme = _ref4.theme,
      expanded = _ref4.expanded;
  return styled_components_1.css(_templateObject8(), expanded ? "visible" : "hidden", theme.transitions.duration["default"], theme.transitions.easing.easeInOut);
});